var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9308 17.04C16.8375 17.0266 16.7175 17.0266 16.6108 17.04C14.2641 16.96 12.3975 15.04 12.3975 12.68C12.3975 10.2666 14.3441 8.30664 16.7708 8.30664C19.1841 8.30664 21.1441 10.2666 21.1441 12.68C21.1308 15.04 19.2775 16.96 16.9308 17.04Z",
    stroke: "#00A14B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7575 25.84C23.3842 28.0133 20.2375 29.3333 16.7708 29.3333C13.3042 29.3333 10.1575 28.0133 7.78418 25.84C7.91751 24.5866 8.71751 23.36 10.1442 22.4C13.7975 19.9733 19.7708 19.9733 23.3975 22.4C24.8242 23.36 25.6242 24.5866 25.7575 25.84Z",
    stroke: "#00A14B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7708 29.3333C24.1346 29.3333 30.1042 23.3638 30.1042 16C30.1042 8.63616 24.1346 2.66663 16.7708 2.66663C9.40704 2.66663 3.4375 8.63616 3.4375 16C3.4375 23.3638 9.40704 29.3333 16.7708 29.3333Z",
    stroke: "#00A14B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.fe269f91e43bff6c4de38333be8a5f74.svg";
export { ForwardRef as ReactComponent };